const SE_IMPACT_ALLOWED_ROLES = ['DSOM', 'FEDERAL', 'GOSI'];
const VE_IMPACT_ALLOWED_ROLES = ['VE'];

/**
 * Frontend-only allowlist for standalone SE Activities & Impact Analysis page.
 * Add approved user emails here; do not duplicate this list elsewhere.
 */
export const SE_IMPACT_STANDALONE_EMAILS = [
  // Anthony de la Fuente (Sales) — must match auth currentUser.email exactly
  'uwe@helixops.ai',
  'sara@helixops.ai',
  'anthony.d@helixops.ai',
];

const normalizeEmail = (value) => (value || '').trim().toLowerCase();

export const canAccessStandaloneSeImpactAnalytics = (user) => {
  if (!user) {
    return false;
  }

  const email = normalizeEmail(user.email);
  if (!email) {
    return false;
  }

  return SE_IMPACT_STANDALONE_EMAILS.some(
    (allowedEmail) => normalizeEmail(allowedEmail) === email
  );
};

const normalizeRole = (value) => {
  const role = (value || '').trim();
  if (role === 'DSOM SE') {
    return 'DSOM';
  }

  return role.toUpperCase();
};

export const canAccessManagerImpactAnalytics = (user, allowedRoles) => {
  if (!user) {
    return false;
  }

  if (user.typeOfUser === 'Admin' && user.isManager) {
    return true;
  }

  const role = normalizeRole(user.roleOfUser || user.role);
  return allowedRoles.includes(role);
};

export const canAccessSeImpactAnalytics = (user) =>
  canAccessManagerImpactAnalytics(user, SE_IMPACT_ALLOWED_ROLES);

export const canAccessVeImpactAnalytics = (user) =>
  canAccessManagerImpactAnalytics(user, VE_IMPACT_ALLOWED_ROLES);
